// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__z_mJ_","box":"styles_box__9IKbM","icon":"styles_icon__BHGqq"};